import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 24",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18.8 16.2004C19.1866 16.2004 19.5 16.5138 19.5 16.9004C19.5 17.287 19.1866 17.6004 18.8 17.6004H6.2C5.8134 17.6004 5.5 17.287 5.5 16.9004C5.5 16.5138 5.8134 16.2004 6.2 16.2004H18.8ZM18.8 11.3004C19.1866 11.3004 19.5 11.6138 19.5 12.0004C19.5 12.387 19.1866 12.7004 18.8 12.7004H6.2C5.8134 12.7004 5.5 12.387 5.5 12.0004C5.5 11.6138 5.8134 11.3004 6.2 11.3004H18.8ZM18.8 6.40039C19.1866 6.40039 19.5 6.71379 19.5 7.10039C19.5 7.48699 19.1866 7.80039 18.8 7.80039H6.2C5.8134 7.80039 5.5 7.48699 5.5 7.10039C5.5 6.71379 5.8134 6.40039 6.2 6.40039H18.8Z" }, null, -1)
  ]))]))
}
export default { render: render }